import { CustomValueImportRowsParams } from "PFCore/services/admin/imports/fetch_custom_value_import_rows";
import { CustomValuesImportsParams } from "PFCore/services/admin/imports/fetch_custom_values_imports";
import { Id } from "PFTypes";

export const customValuesImportsKeys = {
  all: () => ["customValuesImports"],
  ofType: (customTypeId: Id, params?: CustomValuesImportsParams) => [
    ...customValuesImportsKeys.all(),
    customTypeId,
    params
  ]
};

export const customValueImportRowsKeys = {
  all: () => ["importRows"],
  import: (id: Id, params?: CustomValueImportRowsParams) => [...customValueImportRowsKeys.all(), id, params]
};
